export const copy = css`
  max-width: var(--measure3);
  line-height: var(--lh2);
`

///////////////////////////////////////////////////////////////////////////////////

import { css } from 'styled-components'
